export const selectionsWithTimes = [
  {
    id: 17,
    name: null,
    minimumSelections: 1,
    maximumSelections: 1,
    optionsPerGuest: true,
    isExtras: false,
    supportsSelections: true,
    isRequired: true,
    isBookable: true,
    options: [
      {
        id: 55,
        name: 'Express Manicure',
        description: null,
        image: {
          externalKey: '4246a76409f44d3a7134db035a7fa886',
          url: 'https://products-stage-onejourney-private.s3.amazonaws.com/4246a76409f44d3a7134db035a7fa886.jpg',
        },
        price: null,
        extra: null,
        timeslots: [
          {
            startTime: '09:00:00',
            endTime: '09:30:00',
            price: {
              amount: 2200,
              currencyCode: 'gbp',
            },
            quantity: 10,
            durationMinutes: 60,
          },
          {
            startTime: '09:15:00',
            endTime: '09:45:00',
            price: {
              amount: 2200,
              currencyCode: 'gbp',
            },
            quantity: 10,
            durationMinutes: 60,
          },
          {
            startTime: '09:30:00',
            endTime: '10:00:00',
            price: {
              amount: 2200,
              currencyCode: 'gbp',
            },
            quantity: 10,
            durationMinutes: 60,
          },
          {
            startTime: '09:45:00',
            endTime: '10:15:00',
            price: {
              amount: 2200,
              currencyCode: 'gbp',
            },
            quantity: 10,
            durationMinutes: 60,
          },
          {
            startTime: '10:00:00',
            endTime: '10:30:00',
            price: {
              amount: 2200,
              currencyCode: 'gbp',
            },
            quantity: 10,
            durationMinutes: 60,
          },
          {
            startTime: '10:15:00',
            endTime: '10:45:00',
            price: {
              amount: 2200,
              currencyCode: 'gbp',
            },
            quantity: 10,
            durationMinutes: 60,
          },
          {
            startTime: '10:30:00',
            endTime: '11:00:00',
            price: {
              amount: 2200,
              currencyCode: 'gbp',
            },
            quantity: 10,
            durationMinutes: 60,
          },
          {
            startTime: '10:45:00',
            endTime: '11:15:00',
            price: {
              amount: 2200,
              currencyCode: 'gbp',
            },
            quantity: 10,
            durationMinutes: 60,
          },
          {
            startTime: '11:00:00',
            endTime: '11:30:00',
            price: {
              amount: 2200,
              currencyCode: 'gbp',
            },
            quantity: 10,
            durationMinutes: 60,
          },
          {
            startTime: '11:15:00',
            endTime: '11:45:00',
            price: {
              amount: 2200,
              currencyCode: 'gbp',
            },
            quantity: 10,
            durationMinutes: 60,
          },
          {
            startTime: '11:30:00',
            endTime: '12:00:00',
            price: {
              amount: 2200,
              currencyCode: 'gbp',
            },
            quantity: 10,
            durationMinutes: 60,
          },
          {
            startTime: '11:45:00',
            endTime: '12:15:00',
            price: {
              amount: 2200,
              currencyCode: 'gbp',
            },
            quantity: 10,
            durationMinutes: 60,
          },
        ],
      },
      {
        id: 56,
        name: 'Express Pedicure',
        description: null,
        image: {
          externalKey: 'f7a2819e6e569625effef76aedc6b791',
          url: 'https://products-stage-onejourney-private.s3.amazonaws.com/f7a2819e6e569625effef76aedc6b791.jpg',
        },
        price: null,
        extra: null,
        timeslots: [
          {
            startTime: '09:00:00',
            endTime: '09:30:00',
            price: {
              amount: 2600,
              currencyCode: 'gbp',
            },
            quantity: 10,
            durationMinutes: 60,
          },
          {
            startTime: '09:15:00',
            endTime: '09:45:00',
            price: {
              amount: 2600,
              currencyCode: 'gbp',
            },
            quantity: 10,
            durationMinutes: 60,
          },
          {
            startTime: '09:30:00',
            endTime: '10:00:00',
            price: {
              amount: 2600,
              currencyCode: 'gbp',
            },
            quantity: 10,
            durationMinutes: 60,
          },
          {
            startTime: '09:45:00',
            endTime: '10:15:00',
            price: {
              amount: 2600,
              currencyCode: 'gbp',
            },
            quantity: 10,
            durationMinutes: 60,
          },
          {
            startTime: '10:00:00',
            endTime: '10:30:00',
            price: {
              amount: 2600,
              currencyCode: 'gbp',
            },
            quantity: 10,
            durationMinutes: 60,
          },
          {
            startTime: '10:15:00',
            endTime: '10:45:00',
            price: {
              amount: 2600,
              currencyCode: 'gbp',
            },
            quantity: 10,
            durationMinutes: 60,
          },
          {
            startTime: '10:30:00',
            endTime: '11:00:00',
            price: {
              amount: 2600,
              currencyCode: 'gbp',
            },
            quantity: 10,
            durationMinutes: 60,
          },
          {
            startTime: '10:45:00',
            endTime: '11:15:00',
            price: {
              amount: 2600,
              currencyCode: 'gbp',
            },
            quantity: 10,
            durationMinutes: 60,
          },
          {
            startTime: '11:00:00',
            endTime: '11:30:00',
            price: {
              amount: 2600,
              currencyCode: 'gbp',
            },
            quantity: 10,
            durationMinutes: 60,
          },
          {
            startTime: '11:15:00',
            endTime: '11:45:00',
            price: {
              amount: 2600,
              currencyCode: 'gbp',
            },
            quantity: 10,
            durationMinutes: 60,
          },
          {
            startTime: '11:30:00',
            endTime: '12:00:00',
            price: {
              amount: 2600,
              currencyCode: 'gbp',
            },
            quantity: 10,
            durationMinutes: 60,
          },
          {
            startTime: '11:45:00',
            endTime: '12:15:00',
            price: {
              amount: 2600,
              currencyCode: 'gbp',
            },
            quantity: 10,
            durationMinutes: 60,
          },
        ],
      },
    ],
  },
];
